import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import useErrorMessage from 'shared/components/error/hooks';
import ErrorMessageProviderContext from 'shared/components/error/providers/contexts/error-message-context';

import styles from './error-message.module.scss';

const ErrorMessage = (): React.JSX.Element => {
  const { t } = useTranslation('errorHandling');
  const { localErrorMsgTKey } = useErrorMessage();
  const { setErrorMessage } = use(ErrorMessageProviderContext);

  return (
    <>
      {localErrorMsgTKey && (
        <Snackbar
          data-testid="error-message-snackbar"
          open={localErrorMsgTKey !== null}
          autoHideDuration={5000}
          onClose={() => setErrorMessage(undefined)}
        >
          <MuiAlert
            className={styles.errorMessage}
            data-testid="error-alert"
            elevation={6}
            variant="filled"
            onClose={() => setErrorMessage(undefined)}
            severity="error"
          >
            {localErrorMsgTKey && t(localErrorMsgTKey)}
          </MuiAlert>
        </Snackbar>
      )}
    </>
  );
};

export default ErrorMessage;
